module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="info-block">\n	<h2>THIS IS A 404 ERROR.</h2>\n	<p>\n		We couldn’t find the page that you are looking for.\n		Please try refreshing the page or return to the homepage.\n	</p>\n	<a href="/" class="base-btn primary-btn active-btn">RETURN HOME</a>\n</div>';
}
return __p;
};
